export default function parseResolutions(resolutions) {
  return {
    horizontal: parseFloat(resolutions.split(/x/i)[0]),
    vertical: parseFloat(resolutions.split(/x/i)[1])
  }
}



// WEBPACK FOOTER //
// ./src/helpers/parseResolutions.js